<template><svg width="24"
		height="24"
		viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M5.33331 0L1.77777 3.54667H4.44444V9.77779H6.22219V3.54667H8.88885L5.33331 0Z" fill="currentColor" />
	<path d="M11.5555 12.4533V6.2222H9.77775V12.4533H7.11108L10.6666 16L14.2222 12.4533H11.5555Z" fill="currentColor" />
</svg>
</template>
